module.exports = __webpack_public_path__ + "img/hk_lv1_product@2x.be2140ff.png";